import angular from "angular";

interface IResponseHandlerService {
    navigateWhenStatuses(response: $TSFixMe, statuses: number[], state: string): $TSFixMe;
}

export class ResponseHandlerService implements IResponseHandlerService {
    public static componentName = "responseHandlerService";
    static $inject = ["$state"];

    constructor(private $state: ng.ui.IStateService) { }

    navigateWhenStatuses(response: { data: $TSFixMe; status: number }, statuses: number[], state: string): $TSFixMe {
        if (statuses.includes(response.status)) {
            this.$state.go(state);
        } else {
            return response.data;
        }
    }

    navigateWhenNull<TResult>(result: TResult, state: string): $TSFixMe {
        if (result === null || result === undefined) {
            this.$state.go(state);
        } else {
            return result;
        }
    }
}

angular.module("topline.services").service(ResponseHandlerService.componentName, ResponseHandlerService);
